<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="EP">I stand before the masters who know the histories of the dead, who decide which tales to hear again, who judge the book of lives as either full or empty, who are themselves authors of truth.… When the story is written and the end is good and the soul of a man is perfected, with a shout they lift him into heaven.</p>
<p class="EPC"><span class="ePub-I">—Egyptian Book of the Dead</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?2a4a9fd5